var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreasury(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5L5 5.83333M5 5.83333L2.5 13.3333C3.22142 13.8742 4.09876 14.1666 5.00042 14.1666C5.90207 14.1666 6.77942 13.8742 7.50083 13.3333L5 5.83333ZM5 5.83333L7.5 13.3333M5 5.83333L10 4.16667M10 4.16667L15 5.83333M10 4.16667V2.5M10 4.16667V17.5M15 5.83333L17.5 5M15 5.83333L12.5 13.3333C13.2214 13.8742 14.0988 14.1666 15.0004 14.1666C15.9021 14.1666 16.7794 13.8742 17.5008 13.3333L15 5.83333ZM10 17.5H7.5M10 17.5H12.5",
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasury);
export default __webpack_public_path__ + "static/media/treasury.a5aa8e1611967b07a3cf4ae6b7d58483.svg";
export { ForwardRef as ReactComponent };